import styled from 'styled-components';
import { SUBMISSION_COLOR_MAP } from './constants';

export const DivStatusLabel = styled.div<{ status: number }>`
  font-size: 1rem;
  line-height: 1.2rem;
  font-weight: bold;
  color: ${({ status }) => SUBMISSION_COLOR_MAP[status]};
`;
